import { render, staticRenderFns } from "./CustomHeaderExpandable.vue?vue&type=template&id=25a84e0a&"
import script from "./CustomHeaderExpandable.vue?vue&type=script&lang=ts&"
export * from "./CustomHeaderExpandable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VExpandTransition,VIcon})
